// AdminSchema.js
// Matches the same shape/style as PermissionGroupSchema.js
import { DATE_TIME_FORMAT_REG_EXP } from "utils/datetime";

export const policyTypesFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "code",
    dataType: "Text",
    shownOnForm: true,
    label: "Code",
    value: "",
    isRequired: true,
    maxChar: 30,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_]+$/,
    patternMessage:
      "Invalid code. You can use letters, numbers or characters such as -, _ e.g A0001-001",
  },
  {
    id: "name",
    dataType: "Text",
    shownOnForm: true,
    label: "Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "status",
    dataType: "Text",
    shownOnForm: true,
    label: "Status",
    value: "active",
    isRequired: true,
    maxChar: 50,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
    ],
  },
];

export const policyTypesRecord = {
  id: 0,
  code: "",
  name: "",
  status: "active",
};
